import * as React from 'react';
import { cn } from '../../lib/cn';

/**
 * Bubble — framed conversational content (shadcn's new conversation layer).
 * Themed onto HofSync brand tokens; user = ACKERDOKU yellow, assistant = card.
 */
export interface BubbleProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'user' | 'assistant';
}

export const Bubble = React.forwardRef<HTMLDivElement, BubbleProps>(
  ({ className, variant = 'assistant', ...props }, ref) => (
    <div
      ref={ref}
      data-variant={variant}
      className={cn(
        'tw:max-w-[80%] tw:rounded-2xl tw:px-4 tw:py-2 tw:text-sm tw:leading-relaxed',
        variant === 'user'
          ? 'tw:ml-auto tw:rounded-br-sm tw:bg-primary tw:text-primary-foreground'
          : 'tw:mr-auto tw:rounded-bl-sm tw:border tw:border-border tw:bg-card tw:text-card-foreground',
        className
      )}
      {...props}
    />
  )
);
Bubble.displayName = 'Bubble';
